export const CSS_VARIABLES_COLORS_CONFIG: Record<string, string> = {
  "--swiper-theme-color": "var(--secondary)",
}

const CSS_VARIABLES_PAGINATION: Record<string, string> = {
  "--swiper-pagination-bullet-width": "1rem",
  "--swiper-pagination-bullet-height": "1rem",
  "--swiper-pagination-bullet-horizontal-gap": ".5rem",
  "--swiper-pagination-bullet-inactive-opacity": "1",
  "--swiper-pagination-color": "var(--secondary)",
  "--swiper-pagination-bullet-inactive-color": `#EDEDED`,
}

const CSS_VARIABLES_NAVIGATION: Record<string, string> = {
  "--swiper-navigation-size": "20px",
  "--swiper-navigation-color": "var(--secondary)",
}

export const CSS_VARIABLES: Record<string, string> = {
  ...CSS_VARIABLES_COLORS_CONFIG,
  ...CSS_VARIABLES_PAGINATION,
  ...CSS_VARIABLES_NAVIGATION,
}
